import styles from './GlobalEmptyState.module.css';

export function EmptyStateGraphic() {
  return (
    <svg
      className={styles.graphic}
      viewBox="0 0 120 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect
        x="28"
        y="12"
        width="72"
        height="52"
        rx="10"
        strokeWidth="1.5"
        className={`${styles.graphicAccentFillSoft} ${styles.graphicAccentStrokeSoft}`}
        transform="rotate(6 64 38)"
      />
      <rect
        x="16"
        y="28"
        width="72"
        height="52"
        rx="10"
        fill="currentColor"
        fillOpacity="0.04"
        strokeWidth="1.5"
        strokeDasharray="5 4"
        className={styles.graphicAccentStroke}
      />
      <line
        x1="28"
        y1="46"
        x2="76"
        y2="46"
        strokeWidth="2"
        strokeLinecap="round"
        className={styles.graphicAccentLine}
      />
      <line
        x1="28"
        y1="56"
        x2="64"
        y2="56"
        stroke="currentColor"
        strokeOpacity="0.08"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="28"
        y1="66"
        x2="70"
        y2="66"
        stroke="currentColor"
        strokeOpacity="0.08"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="92" cy="24" r="5" className={styles.graphicAccentDot} />
      <circle cx="102" cy="34" r="2.5" className={styles.graphicAccentDotFade} />
    </svg>
  );
}
